import React from "react";
import StdAssignment from "../../components/StudentTabs/StudentAssignment/StdAssignment";


const Assignment = () => {
  return (
    <div>
      <br/>
      <StdAssignment/>
    </div>
  );
};

export default Assignment;
